import React from 'react';
import { useLocalizedStrings } from '../../Localization';
import { AdminPanelPage } from '../AdminPanelPage';
import { BreadcrumbProps } from '@aidkitorg/component-library';

export const OnSiteIntakePage: React.FC = () => {
  const L = useLocalizedStrings();

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.applicants
    },
    {
      label: 'On-Site Intake'
    }
  ];

  return (
    <AdminPanelPage
      title="On-Site Intake"
      description="Manage on-site intake processes"
      breadcrumbs={breadcrumbs}
    >
      <div className="flex flex-col items-center justify-center py-16">
      </div>
    </AdminPanelPage>
  );
};

export default OnSiteIntakePage;
